export default __webpack_public_path__ + "5bccb8f945a4d71c29e3a1c3e7374913.svg";